import { LearningResourceFeePriceDto } from './learningresourcefeepricedto';
import { pageDto } from './pagedto';

export class LearningResourceFeePriceResponse {

    listLearningResourceFeePriceDto: LearningResourceFeePriceDto[] = [];

    pageDto: pageDto = new pageDto({});
}